<template>
	<component :is="componentName" v-bind="$props" @initData="data => $emit('initData', data)" @input="input"
		@change="change" @clear="clear">
		<template slot-scope="{item}">
			<slot :item="item"></slot>
		</template>
	</component>
</template>

<script>
import FuzzyInput from './FuzzyInput'
import FuzzySelect from './FuzzySelect'
import setData from './setting.js'
export default {
	name: 'FuzzyQuery',
	components: { FuzzyInput, FuzzySelect },
	props: {
		// 双向绑定
		value: {
			required: true,
		},
		valueKey: {
			type: String,
			default: ''
		},
		selectKey: {
			type: String,
			default: ''
		},
		// 选择input类型还是select类型
		type: {
			type: String,
			default: 'input'
		},
		// input/select的 placeholder
		placeholder: {
			type: String,
		},
		// 建议选项的标识
		sign: {
			type: String,
			required: true
		},
		// 建议选项请求参数
		params: {
			type: Object,
			default: () => {
				return {}
			}
		},
		// 是否可清除
		clearable: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		// 禁用选项
		disabledOptions: {
			type: Function,
			default: (row) => false
		},
		filterOptions: {
			type: Function,
			default: (row) => true
		},
		// 去重键
		dedupeKey: {
			type: String,
			default: ''
		},
		// 展开下拉时是否重新拉取最新数据
		refreshOnOpen: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {
		}
	},
	computed: {
		componentName() {
			return (this.type == 'input' || this.type == 'input_select') ? 'FuzzyInput' : 'FuzzySelect'
		}
	},
	watch: {
	},
	created() {

	},
	methods: {
		input(val) {
			this.$emit('input', val)
		},
		change(val, row) {
			if ((this.type == 'input' || this.type == 'input_select') && (this.valueKey || setData[this.sign].option.key)) {
				this.$emit('update:selectKey', row ? row[this.valueKey || setData[this.sign].option.key] : '')
			}
			this.$emit('input', val)
			this.$emit('change', val, row)
		},
		select(val, row) {
			if (this.type == 'input_select' && (this.valueKey || setData[this.sign].option.key)) {
				this.$emit('update:selectKey', row ? row[this.valueKey || setData[this.sign].option.key] : '')
			}
		},
		clear() {
			this.$emit('clear')
		}
	},

}
</script>
